// extracted by mini-css-extract-plugin
export default {"ResetPasswordFormContainer":"ResetPasswordForm_ResetPasswordFormContainer__qjo-r","Form":"ResetPasswordForm_Form__6Ky2i","SendButton":"ResetPasswordForm_SendButton__e4GDn"};